import { useState, useEffect, useRef } from "react";
import { setUserEntry, LogOut, updateStationId } from "../../server/Customer";
import { globalFileIcon } from "../../../axiosInstance";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import Accessibility from "../Accessibility";
import CustomerService from "../customerService/CustomerService";
import PrivateAreaList from "../privateArea/PrivateAreaList";
import { FiArrowRight } from "react-icons/fi";
import {
  Headset,
  Settings,
  X as CloseIcon,
  LogIn,
  User,
  LogOut as LogOutIcon,
} from "lucide-react";
import { getStationsFromPGW } from "../../server/Station";
import HeaderSearch from "./HeaderSearch";
import { setClientView } from "../../server/Category";
import { setStatus } from "../../server/Category";
import AnchoredPortal from "../ui/AnchoredPortal";

const HeaderConnection = ({
  user,
  stationId,
  role,
  setAllProduct,
  haveGetToken,
  basicHeader,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const [openPrivateAreaList, setOpenPrivateAreaList] = useState(false);
  const customerServiceBtnRef = useRef(null);
  const personalAreaBtnRef = useRef(null);
  const [adminStation, setAdminStation] = useState([]);
  const [displayMode, setDisplayMode] = useState(
    sessionStorage.getItem("adminDisplayMode") || "allProduct",
  );

  const exit = () => {
    dispatch(LogOut());
    dispatch(setUserEntry([true, "login"]));
    navigate("/");
    haveGetToken();
  };

  const check = async (stationId) => {
    sessionStorage.setItem("stationId", stationId);
    dispatch(updateStationId(stationId));
    if (user) {
      user.StationId = stationId;
    }
  };

  useEffect(() => {
    if (role) {
      getStationsFromPGW()
        .then((stations) => {
          setAdminStation(stations.data);
          const savedStationId = sessionStorage.getItem("stationId");
          if (savedStationId) {
            const exists = stations.data.some(
              (s) => String(s.id) === String(savedStationId),
            );
            if (exists)
              dispatch(updateStationId(savedStationId));
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [role]);

  useEffect(() => {
    const saved = sessionStorage.getItem("adminDisplayMode");
    if (saved && role) {
      changeProductDisplay(saved);
    }
    // changeProductDisplay is defined below and is stable in effect intent for this mount path.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  const changeProductDisplay = (value) => {
    sessionStorage.setItem("adminDisplayMode", value);
    setDisplayMode(value);
    switch (value) {
      case "allProduct":
        setAllProduct(true);
        dispatch(setClientView(false));
        dispatch(setStatus(true));
        break;
      case "active":
        setAllProduct(false);
        dispatch(setClientView(false));
        dispatch(setStatus(false));
        break;
      case "customer":
        setAllProduct(false);
        dispatch(setClientView(true));
        dispatch(setStatus(false));
        break;
      default:
        console.warn("ערך לא מוכר:", value);
    }
  };

  const isGuest = !user || localStorage.getItem("userRole")?.includes("guest");

  return (
    <div className="header-connection">
      <div className="back-and-logo">
        <button className="back-button" onClick={() => navigate(-1)}>
          <FiArrowRight />
        </button>
        {!basicHeader && (
          <NavLink to="/" className="site-icon">
            <img
              loading="lazy"
              src={globalFileIcon + "new-site-icon.svg"}
              alt="site"
            />
          </NavLink>
        )}
      </div>
      {!basicHeader ? (
        <>
          <HeaderSearch />
          <div className="header-data">
            <nav className="header-nav-pill" aria-label="ניווט ראשי">
              <button
                type="button"
                className={`nav-pill-btn nav-pill-btn--icon-only${openMenu ? " nav-pill-btn--active" : ""}`}
                onClick={() => setOpenMenu(true)}
                onKeyDown={(e) => {
                  if (e.key === "Escape") setOpenMenu(false);
                  if (e.key === "Enter" || e.key === " ") setOpenMenu(true);
                }}
                aria-haspopup="dialog"
                aria-expanded={openMenu}
                aria-label="שירות לקוחות"
                ref={customerServiceBtnRef}
              >
                <Headset size={18} strokeWidth={2} aria-hidden />
                <span>שירות לקוחות</span>
              </button>
              <Accessibility />
              {user && !role && !isGuest && (
                <button
                  type="button"
                  onClick={() => setOpenPrivateAreaList(true)}
                  className={`nav-pill-btn${openPrivateAreaList ? " nav-pill-btn--active" : ""}`}
                  aria-label={user?.firstName || "אזור אישי"}
                  ref={personalAreaBtnRef}
                >
                  <User size={18} strokeWidth={2} aria-hidden />
                  <span>{user?.firstName || "אזור אישי"}</span>
                </button>
              )}
              {isGuest && (
                <button
                  type="button"
                  className="nav-pill-btn"
                  onClick={() => dispatch(setUserEntry([true, "login"]))}
                  aria-label="כניסה"
                >
                  <LogIn size={18} strokeWidth={2} aria-hidden />
                  <span>כניסה</span>
                </button>
              )}
            </nav>
            <AnchoredPortal
              anchorRef={customerServiceBtnRef}
              open={openMenu}
              placement="bottom-end"
              offset={10}
            >
              <div className="customer-service-menu">
                <CustomerService setOpenMenu={setOpenMenu} />
              </div>
            </AnchoredPortal>
            {user && !role && !isGuest && (
              <AnchoredPortal
                anchorRef={personalAreaBtnRef}
                open={openPrivateAreaList}
                placement="bottom-end"
                offset={10}
              >
                <div className="private-area-list-menu">
                  <PrivateAreaList
                    setOpenPrivateAreaList={setOpenPrivateAreaList}
                    onLogout={exit}
                  />
                </div>
              </AnchoredPortal>
            )}
          </div>
        </>
      ) : (
        <h2>פאנל הניהול</h2>
      )}

      <div className="login-or-sign-in">
        {role ? (
          <nav
            className="header-nav-pill header-nav-pill--admin"
            aria-label="פעולות מנהל"
          >
            {!basicHeader && (
              <NavLink
                to="/admin/users"
                className="nav-pill-btn nav-pill-btn--icon-only"
                aria-label="הגדרות"
              >
                <Settings size={18} strokeWidth={2} aria-hidden />
                <span>הגדרות</span>
              </NavLink>
            )}
            {!basicHeader && (
              <label className="nav-pill-btn nav-pill-btn--select">
                <select
                  className="nav-pill-btn__select"
                  value={displayMode}
                  onChange={(e) => changeProductDisplay(e.target.value)}
                >
                  <option value="allProduct">תצוגת כל המוצרים</option>
                  <option value="active">תצוגת פעילים</option>
                  <option value="customer">תצוגת לקוח</option>
                </select>
              </label>
            )}
            <label className="nav-pill-btn nav-pill-btn--select">
              <span>מנהל /</span>
              <select
                className="nav-pill-btn__select"
                value={stationId || ""}
                onChange={(e) => check(e.target.value)}
              >
                {adminStation.map((station) => (
                  <option key={station.id} value={station.id}>
                    {station.name}
                  </option>
                ))}
              </select>
            </label>
            <button
              type="button"
              onClick={() => exit()}
              className="nav-pill-btn"
              aria-label="יציאה"
            >
              <LogOutIcon size={18} strokeWidth={2} aria-hidden />
              <span>יציאה</span>
            </button>
            {basicHeader && (
              <NavLink to="/" className="nav-pill-btn">
                <CloseIcon size={18} strokeWidth={2} aria-hidden />
                <span>סגור</span>
              </NavLink>
            )}
          </nav>
        ) : null}
      </div>
    </div>
  );
};

export default HeaderConnection;